import styled from 'styled-components';

export const MediaCarouselContainer = styled.div`
  position: relative;
  height: 400px;
  overflow: hidden;
  border-radius: 8px;
  margin: 10px 0px;

  .media-carousel {
    .slider-wrapper.axis-horizontal {
      .slider {
        gap: 5px;
        justify-content: center;
      }
    }
    .slide {
      img {
        max-height: 350px;
        object-fit: cover;
      }
    }
  }
  @media (max-width: 768px) {
    .media-carousel {
      .slider-wrapper.axis-horizontal {
        .slider {
          gap: 2px;
        }
      }
      .slide {
        img {
          height: 250px;
          object-fit: cover;
        }
      }
      .carousel-slider {
        center-slide-percentage: 100%;
      }

      .slider {
        min-width: 100%;
      }
    }
  }
`;

export const MediaWrapper = styled.div`
  cursor: pointer;
`;
export const CountIndicator = styled.div`
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 15px;
  padding: 5px 10px;
`;

export const MediaImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 5px;

  @media (max-width: 768px) {
    border-radius: 3px;
  }
`;

export const MediaModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  overflow: hidden;
`;

export const MediaModalContent = styled.img`
  max-width: 90%;
  max-height: 90%;

  @media (max-width: 768px) {
    max-width: 95%;
    max-height: 50%;
    object-fit: contain;
  }
`;

export const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 30px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  font-weight: 500;

  &::before {
    content: '\\00D7';
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }
`;
